const isRdvBeforeHour = (rdv, hourInMinutes) => rdv.hour * 60 + rdv.minute + rdv.duration <= hourInMinutes;
const isRdvAfterHour = (rdv, hourInMinutes) => rdv.hour * 60 + rdv.minute >= hourInMinutes;
const filterAfter = (heureEnMinutes, rdvs) => rdvs.filter((r) => isRdvAfterHour(r, heureEnMinutes));
const filterBefore = (heureEnMinutes, rdvs) => rdvs.filter((r) => isRdvBeforeHour(r, heureEnMinutes));
const rdvsFromPlage = (rdvsDuJour, plage) => {
    const plageStart = plage.start.hour * 60 + plage.start.minute;
    const plageEnd = plage.end.hour * 60 + plage.end.minute;
    const filtered = filterAfter(plageStart, rdvsDuJour);
    return filterBefore(plageEnd, filtered);
};
export default rdvsFromPlage;
//# sourceMappingURL=rdvsFromPlage.js.map